import i18n from 'i18next';
import sv from './sv.json';

i18n.init({
    lng: 'sv',
    resources: {
        sv: { translation: sv }
    }
});

export default i18n;